import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

import { cn } from "../../lib/utils";

export type BreadcrumbItem = {
  label: string;
  to?: string;
  params?: Record<string, string>;
  replace?: boolean;
};

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className={cn("flex items-center gap-1 text-sm", className)}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;

        return (
          <div key={item.label} className="flex items-center gap-1 min-w-0">
            {i > 0 && <ChevronRight className="size-3.5 shrink-0 text-surface-600" />}
            {isLast || !item.to ? (
              <span
                aria-current={isLast ? "page" : undefined}
                className={cn("truncate font-medium", isLast ? "text-white" : "text-surface-400")}
              >
                {item.label}
              </span>
            ) : (
              <Link
                to={item.to}
                params={item.params ?? {}}
                replace={item.replace}
                className="truncate font-medium text-surface-400 hover:text-white transition-colors duration-200"
              >
                {item.label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
